const store = new Map();

export const cachedRequest = (key, ttlMs, requestFn) => {
  const now = Date.now();
  const existing = store.get(key);
  if (existing && existing.expiresAt > now) return existing.value;

  const value = Promise.resolve().then(requestFn);
  store.set(key, { expiresAt: now + ttlMs, value });
  value.catch(() => {
    const cur = store.get(key);
    if (cur && cur.value === value) store.delete(key);
  });
  return value;
};

export const clearCache = (prefix = "") => {
  for (const k of store.keys()) {
    if (prefix ? String(k).startsWith(prefix) : true) store.delete(k);
  }
};

